export default {
    select: "Válassza ki a Szállítási címet",
    shippingRulesTip: "A helyi szállítási szabályokat be kell tartani"
}